module.exports = __webpack_public_path__ + "static/media/mobile-menu.10823520.svg";